import React from "react";
import ReactMarkdown from "react-markdown";
import Button from "@/components/actions/Button";
import * as Text from "@/components/text";
import { Disclosure } from "@headlessui/react";
import { MinusSmIcon, PlusSmIcon } from "@heroicons/react/solid";
import { CheckIcon } from "@heroicons/react/outline";
import Link from "next/link";
import { DownloadIcon } from "@heroicons/react/outline";
import classNames from "classnames";

export default function Announcement({
  data,
  qa,
  isActive,
  inactiveData,
  type,
}) {
  const baseStyle = "w-full py-[60px] px-4 md:px-32 lg:py-32 ";
  const typeStyle = {
    presenta: "bg-presenta",
    "mas-alla": "bg-mas-alla",
  }[type];
  const css = classNames(baseStyle, typeStyle);

  return (
    <div className="mb-8 lg:flex lg:max-w-[1440px]" id="Announcement">
      {isActive ? (
        <div className={css}>
          <div className="flex w-fit rounded-full border border-black px-2 py-1">
            <Text.NavigationLabel className="pr-2 text-xs font-[600]">
              {data?.subtitle}
            </Text.NavigationLabel>
          </div>
          <div className="py-6 text-2xl font-bold">{data?.title}</div>
          <ReactMarkdown
            className={classNames(
              "prose mb-6 prose-h2:uppercase",
              type === "presenta" ? "text-black" : null
            )}
          >
            {data?.description.replace(/<br>/g, "&nbsp; \n")}
          </ReactMarkdown>
          <div className="justify-between gap-4 md:flex">
            <Link
              className="w-full font-bold"
              href="mailto:ama@ambulante.org?subject=Ambulante Más Allá&"
              passHref
              target="_blank"
            >
              <Button
                size="lg"
                color="secondary-light"
                label={type === "presenta" ? "Aplicar ahora" : "Postular ahora"}
                className="w-full font-bold"
              ></Button>
            </Link>
            {type === "presenta" && (
              <Link
                className="w-full font-bold"
                href="mailto:ama@ambulante.org?subject=Ambulante Más Allá&"
                passHref
                target="_blank"
              >
                <Button
                  size="lg"
                  color="terciary-light"
                  label="Descargar catálogo"
                  className="mt-6 w-full font-bold md:mt-0"
                  trailingIcon={<DownloadIcon />}
                ></Button>
              </Link>
            )}
          </div>
        </div>
      ) : (
        <div className="w-full bg-neutral-100 px-4 py-[60px] md:px-32 lg:py-32">
          <div className="flex w-fit rounded-full border border-black px-2 py-1">
            <Text.NavigationLabel className="text-xs font-[600]">
              {inactiveData?.subtitle}
            </Text.NavigationLabel>
          </div>
          <div className="py-6 text-2xl font-bold">{inactiveData?.title}</div>
          <ReactMarkdown className="prose mb-6 prose-h2:uppercase">
            {inactiveData?.description.replace(/<br>/g, "&nbsp; \n")}
          </ReactMarkdown>
          <div className="w-full">
            <form
              action="https://ambulante.us16.list-manage.com/subscribe/post?u=83db27a5962ce56c73cedeb90&amp;id=c39fe7c593&amp;f_id=00dec2e1f0"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              target="_blank"
            >
              <input
                type="email"
                name="EMAIL"
                id="mce-EMAIL"
                className="h-11 w-full border-2 px-3"
                required
                placeholder="ej. tunombre@tucorreo.com"
              ></input>
              <Button
                type="submit"
                color="secondary-light"
                size="lg"
                className="mt-4 w-full"
                trailingIcon={<CheckIcon />}
                label="Suscribir"
              ></Button>
            </form>
            <p className="mt-4 text-xs leading-4 text-neutral-700">
              No te enviaremos SPAM, solo noticias de las próximas convocatorias
            </p>
          </div>
        </div>
      )}
      <div className="w-full bg-neutral-50 px-4 py-10 md:px-32 lg:py-32">
        <Text.Body as="p" className="pb-4 text-sm uppercase text-neutral-500">
          Preguntas frecuentes
        </Text.Body>
        <hr className="h-0.5 w-full bg-gray-300"></hr>

        <dl className="space-y-6 divide-y divide-gray-300/90 border-b border-b-gray-300 pb-4">
          {qa?.map((qa, i) => (
            <Disclosure as="div" key={qa.id} className="pt-6">
              {({ open }) => (
                <>
                  <dt>
                    <Disclosure.Button className="flex w-full items-start justify-between text-left text-gray-900">
                      <span className="text-base font-semibold leading-7">
                        {qa?.question}
                      </span>
                      <span className="ml-6 flex h-7 items-center">
                        {open ? (
                          <MinusSmIcon className="h-6 w-6" aria-hidden="true" />
                        ) : (
                          <PlusSmIcon className="h-6 w-6" aria-hidden="true" />
                        )}
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="mt-2 pr-12">
                    <ReactMarkdown
                      as="div"
                      className="font-body  mt-10 prose-h2:uppercase hover:prose-a:underline  prose-li:my-2 lg:max-w-[100ch]"
                    >
                      {qa?.answer}
                    </ReactMarkdown>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          ))}
        </dl>
      </div>
    </div>
  );
}
